import * as React from 'react'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import Image from "../../common/components/image";

@withNavigation
@withRouteBlocker
@withScrollToTop
export default class extends React.Component<any, any> {

    render() {
        const maintenancePage = require("../../common/images/maintenance.png");

        return (
            <div className="row">
                <Image url={ maintenancePage } alt={ 'Maintenance page' }></Image>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/maintenance.tsx